import { render, staticRenderFns } from "./bindingsales.vue?vue&type=template&id=630a8303&scoped=true&"
import script from "./bindingsales.vue?vue&type=script&lang=js&"
export * from "./bindingsales.vue?vue&type=script&lang=js&"
import style0 from "./bindingsales.vue?vue&type=style&index=0&id=630a8303&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "630a8303",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/manage.pc.frontend-purchase-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('630a8303')) {
      api.createRecord('630a8303', component.options)
    } else {
      api.reload('630a8303', component.options)
    }
    module.hot.accept("./bindingsales.vue?vue&type=template&id=630a8303&scoped=true&", function () {
      api.rerender('630a8303', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Urbanwarehouse/modules/bindingsales.vue"
export default component.exports